// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__19Bb2","colMin":"styles_colMin__3rh_B","colCheckbox":"styles_colCheckbox__1DXLV"};